var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeQuick2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4995 32V19.5C20.4995 19.1685 20.6312 18.8505 20.8657 18.6161C21.1001 18.3817 21.418 18.25 21.7495 18.25H26.7495C27.0811 18.25 27.399 18.3817 27.6334 18.6161C27.8678 18.8505 27.9995 19.1685 27.9995 19.5V32M20.4995 32H1.93287M20.4995 32H27.9995M27.9995 32H34.0662M31.7495 32V12.5817C32.4139 12.1982 32.9811 11.667 33.4072 11.0292C33.8334 10.3914 34.1071 9.6641 34.2071 8.90358C34.3072 8.14307 34.2309 7.36973 33.9842 6.64341C33.7376 5.9171 33.3271 5.25727 32.7845 4.715L30.8012 2.73333C30.3328 2.26436 29.6974 2.00058 29.0345 2H6.96287C6.30005 2.00058 5.66459 2.26436 5.1962 2.73333L3.21454 4.71333C2.67326 5.25623 2.26389 5.91617 2.01798 6.64229C1.77207 7.3684 1.6962 8.14129 1.7962 8.90136C1.8962 9.66143 2.16941 10.3884 2.59476 11.0262C3.02012 11.664 3.58626 12.1956 4.24954 12.58M4.24954 31.9983V12.5833C5.24957 13.16 9.36101 11.3535 10.5002 11.1667C15.5002 15.3333 24.5829 12.595 25.4995 11.5567C26.2632 12.4222 27.3028 12.997 28.4419 13.1836C29.5811 13.3701 30.7497 13.1568 31.7495 12.58",
    stroke: "#7900F8",
    strokeWidth: 2.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeQuick2);
export default __webpack_public_path__ + "static/media/home-quick-2.fe11c7a5b4d6968f1d9e3ec8ca82dcd9.svg";
export { ForwardRef as ReactComponent };